// @flow
import React, { PureComponent } from 'react';
import { dynamicClassName } from 'utils/dynamicClassName';
import { Link } from 'react-router-dom';

type Props = {
  hiddenMenuElements: any,
  noIsHidden?: boolean,
  label?: string,
};

type ComponentState = {
  isOpen: boolean
};

class DropdownMenuElementPlus extends PureComponent<Props, ComponentState> {
  _dropdownmenu: ?HTMLElement;
  _title: ?HTMLElement;
  state: ComponentState = {
    isOpen: false
  };

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: MouseEvent) => {
    if (this._dropdownmenu && !this._dropdownmenu.contains((event.target: any))) {
      this.onClick(event);
    }
  };

  onClick = (e: MouseEvent) => {
    e.preventDefault();
    if (!this.state.isOpen) {
      document.addEventListener('mousedown', this.handleClickOutside, {once: true});
    }
    this.setState({ isOpen: !this.state.isOpen }, () => {
      if (this._title && !this.state.isOpen){
        this._title.blur();
      }
    });
  };

  renderHiddenMenuElements(hiddenMenuElements: any) {
    if (hiddenMenuElements && hiddenMenuElements.length > 0) {
      return hiddenMenuElements.map((element, index) => {
        if (element && element.props && element.props.url) {
          return (
            <li key={index}>
              <Link title={`Se rendre à la page ${element.props.title}`} to={element.props.url}>
                {element.props.title}
              </Link>
            </li>
          );
        }
      });
    } else {
      return '';
    }
  }

  render() {
    const { hiddenMenuElements, label, noIsHidden } = this.props;

    const classNamesLink = dynamicClassName('accordion-trigger');
    this.state.isOpen && classNamesLink.add('is-selected');

    const classNamesDropdownMenu = dynamicClassName('billboard__sub accordion-panel');
    !this.state.isOpen && !noIsHidden && classNamesDropdownMenu.add('is-hidden');

    if (hiddenMenuElements && hiddenMenuElements.length > 0) {
      return (
        <li className="billboard__plus js-menuPlus" ref={c => (this._dropdownmenu = c)}>
          <a
            role="button"
            tabIndex={0}
            onClick={this.onClick}
            className={classNamesLink.build()}
            ref={c => (this._title = c)}
          >
            { label ? label : 'Plus' }
          </a>
          <ul className={classNamesDropdownMenu.build()}>
            {this.renderHiddenMenuElements(hiddenMenuElements)}
          </ul>
        </li>
      );
    }

    return null;
  }
}

export default DropdownMenuElementPlus;
